var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PostHogAdapter_config, _PostHogAdapter_posthog, _PostHogAdapter_previousDistinctId;
const MESSAGES = {
    api_key_required: '[Analytics:PostHog] API key is required',
    initialized: '[Analytics:PostHog] Adapter initialized',
    init_failed: '[Analytics:PostHog] Initialization failed',
    not_initialized: '[Analytics:PostHog] PostHog not initialized',
    event_sent: '[Analytics:PostHog] Event was sent:',
    event_failed: '[Analytics:PostHog] Failed to send event',
    global_props_added: '[Analytics:PostHog] Global properties added:',
    global_props_failed: '[Analytics:PostHog] Failed to add global properties',
    user_changed: '[Analytics:PostHog] User changed:',
    user_check_failed: '[Analytics:PostHog] Failed to check user change',
    destroyed: '[Analytics:PostHog] Adapter destroyed',
};
export class PostHogAdapter {
    constructor(config) {
        this.name = 'PostHog';
        _PostHogAdapter_config.set(this, void 0);
        _PostHogAdapter_posthog.set(this, null);
        _PostHogAdapter_previousDistinctId.set(this, null);
        __classPrivateFieldSet(this, _PostHogAdapter_config, config, "f");
    }
    async init() {
        if (typeof window === 'undefined')
            return false;
        if (!__classPrivateFieldGet(this, _PostHogAdapter_config, "f").apiKey) {
            console.warn(MESSAGES.api_key_required);
            return false;
        }
        try {
            /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
            // @ts-ignore posthog-js is an optional peer dependency
            const { default: posthog } = await import('posthog-js');
            posthog.init(__classPrivateFieldGet(this, _PostHogAdapter_config, "f").apiKey, Object.assign({ api_host: __classPrivateFieldGet(this, _PostHogAdapter_config, "f").host }, __classPrivateFieldGet(this, _PostHogAdapter_config, "f").options));
            __classPrivateFieldSet(this, _PostHogAdapter_posthog, posthog, "f");
            __classPrivateFieldSet(this, _PostHogAdapter_previousDistinctId, posthog.get_distinct_id(), "f");
            if (__classPrivateFieldGet(this, _PostHogAdapter_config, "f").debug)
                console.log(MESSAGES.initialized, __classPrivateFieldGet(this, _PostHogAdapter_config, "f"));
            return true;
        }
        catch (error) {
            console.error(MESSAGES.init_failed, error);
            return false;
        }
    }
    sendEvent(action, data) {
        if (!__classPrivateFieldGet(this, _PostHogAdapter_posthog, "f")) {
            if (__classPrivateFieldGet(this, _PostHogAdapter_config, "f").debug)
                console.warn(MESSAGES.not_initialized);
            return false;
        }
        try {
            __classPrivateFieldGet(this, _PostHogAdapter_posthog, "f").capture(action, data);
            if (__classPrivateFieldGet(this, _PostHogAdapter_config, "f").debug)
                console.log(MESSAGES.event_sent, action, data);
            return true;
        }
        catch (error) {
            if (__classPrivateFieldGet(this, _PostHogAdapter_config, "f").debug)
                console.error(MESSAGES.event_failed, error);
            return false;
        }
    }
    addGlobalProperties(properties) {
        if (!__classPrivateFieldGet(this, _PostHogAdapter_posthog, "f")) {
            if (__classPrivateFieldGet(this, _PostHogAdapter_config, "f").debug)
                console.warn(MESSAGES.not_initialized);
            return false;
        }
        try {
            __classPrivateFieldGet(this, _PostHogAdapter_posthog, "f").register(properties);
            if (__classPrivateFieldGet(this, _PostHogAdapter_config, "f").debug) {
                console.log(MESSAGES.global_props_added, properties);
            }
            return true;
        }
        catch (error) {
            if (__classPrivateFieldGet(this, _PostHogAdapter_config, "f").debug) {
                console.error(MESSAGES.global_props_failed, error);
            }
            return false;
        }
    }
    checkUserChanged() {
        if (!__classPrivateFieldGet(this, _PostHogAdapter_posthog, "f"))
            return false;
        try {
            const currentDistinctId = __classPrivateFieldGet(this, _PostHogAdapter_posthog, "f").get_distinct_id();
            const hasChanged = __classPrivateFieldGet(this, _PostHogAdapter_previousDistinctId, "f") !== currentDistinctId;
            if (hasChanged) {
                if (__classPrivateFieldGet(this, _PostHogAdapter_config, "f").debug) {
                    console.log(MESSAGES.user_changed, __classPrivateFieldGet(this, _PostHogAdapter_previousDistinctId, "f"), '->', currentDistinctId);
                }
                __classPrivateFieldSet(this, _PostHogAdapter_previousDistinctId, currentDistinctId, "f");
            }
            return hasChanged;
        }
        catch (error) {
            if (__classPrivateFieldGet(this, _PostHogAdapter_config, "f").debug) {
                console.error(MESSAGES.user_check_failed, error);
            }
            return false;
        }
    }
    destroy() {
        if (__classPrivateFieldGet(this, _PostHogAdapter_config, "f").debug)
            console.log(MESSAGES.destroyed);
        __classPrivateFieldSet(this, _PostHogAdapter_posthog, null, "f");
        __classPrivateFieldSet(this, _PostHogAdapter_previousDistinctId, null, "f");
    }
}
_PostHogAdapter_config = new WeakMap(), _PostHogAdapter_posthog = new WeakMap(), _PostHogAdapter_previousDistinctId = new WeakMap();
